const SortDropdown = ({ value, onChange }) => (
  <div className="flex lg:justify-end items-center gap-2 font-inter">
    <label className="text-sm text-[#475467] font-normal mr-1">Sort</label>
    <div className="relative lg:w-[100px] w-[80vw] flex items-center border border-[#D3DBDF] rounded-xl bg-[#F7F7F7]">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className=" p-2 appearance-none w-full bg-[#F7F7F7] text-sm text-[#475467] font-normal rounded-xl h-10 outline-none"
      >
        <option value="None">None</option>
        <option value="A-Z">A-Z</option>
        <option value="Z-A">Z-A</option>
      </select>
    </div>
  </div>
);

export default SortDropdown;
